var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFiscalbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318 837 c-93 -34 -168 -66 -168 -72 0 -14 319 -185 345 -185 27 0 345 171 345 185 0 9 -334 137 -350 134 -3 0 -80 -28 -172 -62z m463 -71 c0 -5 -63 -43 -141 -84 -130 -68 -145 -73 -169 -62 -25 12 -21 15 119 86 131 67 190 85 191 60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 714 c-4 -4 -7 -90 -7 -190 l0 -183 43 -34 c99 -79 279 -198 293 -193 11 4 14 41 14 201 0 111 -4 204 -10 215 -5 10 -78 56 -162 102 -181 99 -163 90 -171 82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 631 l-155 -87 -3 -222 c-1 -122 0 -222 4 -222 3 0 77 52 165 116 99 72 161 124 164 137 10 39 1 360 -10 363 -5 1 -80 -37 -165 -85z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFiscalbox);
export default __webpack_public_path__ + "static/media/logo-fiscalbox.49065cb7491c4fcad195c9ebe8ab6d36.svg";
export { ForwardRef as ReactComponent };